import { SDKConfig, TourLoaderEventsType } from './types';
import { MpSdk } from 'src/types';
import { Sweep } from './sweep';
import { Tag } from './tag';
import logger from 'src/logger';
import { Floor } from './floor';
import { Tour } from './tour';
import { NodeFactory } from './scene';
import { EventEmitter, ListenerFn } from 'eventemitter3';
import { NavigationManager } from 'src/service/navigation/NavigationManager';

export { SceneInitEventsTypes } from './scene';

export class TourLoaderSDK {
  private mpSDK: MpSdk;

  private sdkConfig: SDKConfig;

  private iframeWindow: Window;

  tag: Tag;

  sweep: Sweep;

  floor: Floor;

  tour: Tour;

  scene: NodeFactory;

  showcase: any;

  navigationManager: NavigationManager;

  on: (type: TourLoaderEventsType, callback: ListenerFn) => void;

  emit: (type: TourLoaderEventsType, data?: unknown) => void;

  off: (type: TourLoaderEventsType, callback: ListenerFn) => void;

  constructor() {
    const interaction = new EventEmitter();

    this.on = function (type: TourLoaderEventsType, callback: ListenerFn) {
      interaction.on(type, callback);
    };

    this.emit = function (type: TourLoaderEventsType, data?: any) {
      interaction.emit(type, data);
    };
    this.off = function (type: TourLoaderEventsType, callback?: ListenerFn) {
      interaction.off(type, callback);
    };
  }

  async connect(iframe: HTMLElement, config: SDKConfig): Promise<any> {
    this.sdkConfig = config;
    // @ts-ignore
    this.mpSDK = await iframe.contentWindow.MP_SDK.connect(iframe, { auth: config.auth });
    // @ts-ignore
    this.iframeWindow = iframe.contentWindow;
    this.showcase = this.mpSDK;
    await this.mpSDK.Settings.update('highlight_reel', false);
    await this.mpSDK.Settings.update('tour_buttons', false);

    let starting = false;
    this.mpSDK.App.state.subscribe(async (appState: any) => {
      if (appState.phase === this.mpSDK.App.Phase.LOADING) {
        this.emit(TourLoaderEventsType.LOADING);
      }
      if (appState.phase === this.mpSDK.App.Phase.STARTING) {
        starting = true;
        await this.init();
        this.emit(TourLoaderEventsType.STARTING);
      }
      if (appState.phase === this.mpSDK.App.Phase.PLAYING) {
        if (!starting) await this.init(); //some tours don't have starting mode
        this.emit(TourLoaderEventsType.PLAYING);
      }
    });

    return this;
  }

  private async init() {
    this.tag = new Tag(this.mpSDK, this.sdkConfig.appAws, this.sdkConfig.appDomain);
    this.sweep = new Sweep(this.mpSDK);
    this.floor = new Floor(this.mpSDK);
    this.tour = new Tour(this.mpSDK);
    this.scene = new NodeFactory(this.mpSDK, this.sdkConfig, this.iframeWindow);
    await this.scene.init();
    this.navigationManager = new NavigationManager(this.mpSDK);
  }
}

export const GetSDK = function (
  element: string | HTMLIFrameElement,
  config: SDKConfig,
): Promise<any> {
  if (config.disableConsole) logger.toggleConsole(config.disableConsole);

  return new Promise((resolve) => {
    const checkIframe = async () => {
      const iframe =
        element instanceof HTMLIFrameElement
          ? (element as HTMLIFrameElement)
          : document.getElementById(element);

      if (iframe && (iframe as any).contentWindow.MP_SDK) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        clearInterval(intervalId);

        if (config.auth) {
          try {
            const response = await fetch(`${config.appDomain}/v1/public/oauth/check`, {
              method: 'POST',
              headers: {
                'Content-type': 'application/json',
              },
              body: JSON.stringify({
                auth: config.auth,
                matterId: config.matterId,
              }),
            });
            //if response is not 200, auth is not valid
            if (response.status != 200) {
              throw new Error(`Invalid auth ${config.auth}.. removing auth`);
            }
          } catch (e) {
            console.error(e);
            config.auth = undefined;
          }
        }

        const showcase = await new TourLoaderSDK().connect(iframe, config);

        // @ts-ignore
        return resolve(showcase);
      } else {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        intervalId = setTimeout(checkIframe, 200);
      }
    };
    let intervalId = setTimeout(checkIframe, 200);
  });
};
